
export function optionUTC() {
    return [
        {
            id: "Africa",
            label: "Africa",
            children: [
                {
                    id: "Africa/Abidjan",
                    label: "(GMT+00:00) Abidjan"
                },
                {
                    id: "Africa/Accra",
                    label: "(GMT+00:00) Accra"
                },
                {
                    id: "Africa/Bamako",
                    label: "(GMT+00:00) Bamako"
                },
                {
                    id: "Africa/Banjul",
                    label: "(GMT+00:00) Banjul"
                },
                {
                    id: "Africa/Bissau",
                    label: "(GMT+00:00) Bissau"
                },
                {
                    id: "Africa/Casablanca",
                    label: "(GMT+00:00) Casablanca"
                },
                {
                    id: "Africa/Conakry",
                    label: "(GMT+00:00) Conakry"
                },
                {
                    id: "Africa/Dakar",
                    label: "(GMT+00:00) Dakar"
                },
                {
                    id: "Africa/El_Aaiun",
                    label: "(GMT+00:00) El Aaiun"
                },
                {
                    id: "Africa/Freetown",
                    label: "(GMT+00:00) Freetown"
                },
                {
                    id: "Africa/Lome",
                    label: "(GMT+00:00) Lome"
                },
                {
                    id: "Africa/Monrovia",
                    label: "(GMT+00:00) Monrovia"
                },
                {
                    id: "Africa/Nouakchott",
                    label: "(GMT+00:00) Nouakchott"
                },
                {
                    id: "Africa/Ouagadougou",
                    label: "(GMT+00:00) Ouagadougou"
                },
                {
                    id: "Africa/Sao_Tome",
                    label: "(GMT+00:00) Sao Tome"
                },
                {
                    id: "Africa/Algiers",
                    label: "(GMT+01:00) Algiers"
                },
                {
                    id: "Africa/Bangui",
                    label: "(GMT+01:00) Bangui"
                },
                {
                    id: "Africa/Brazzaville",
                    label: "(GMT+01:00) Brazzaville"
                },
                {
                    id: "Africa/Ceuta",
                    label: "(GMT+01:00) Ceuta"
                },
                {
                    id: "Africa/Douala",
                    label: "(GMT+01:00) Douala"
                },
                {
                    id: "Africa/Kinshasa",
                    label: "(GMT+01:00) Kinshasa"
                },
                {
                    id: "Africa/Lagos",
                    label: "(GMT+01:00) Lagos"
                },
                {
                    id: "Africa/Libreville",
                    label: "(GMT+01:00) Libreville"
                },
                {
                    id: "Africa/Luanda",
                    label: "(GMT+01:00) Luanda"
                },
                {
                    id: "Africa/Malabo",
                    label: "(GMT+01:00) Malabo"
                },
                {
                    id: "Africa/Ndjamena",
                    label: "(GMT+01:00) Ndjamena"
                },
                {
                    id: "Africa/Niamey",
                    label: "(GMT+01:00) Niamey"
                },
                {
                    id: "Africa/Porto-Novo",
                    label: "(GMT+01:00) Porto-Novo"
                },
                {
                    id: "Africa/Tunis",
                    label: "(GMT+01:00) Tunis"
                },
                {
                    id: "Africa/Windhoek",
                    label: "(GMT+01:00) Windhoek"
                },
                {
                    id: "Africa/Blantyre",
                    label: "(GMT+02:00) Blantyre"
                },
                {
                    id: "Africa/Bujumbura",
                    label: "(GMT+02:00) Bujumbura"
                },
                {
                    id: "Africa/Cairo",
                    label: "(GMT+02:00) Cairo"
                },
                {
                    id: "Africa/Gaborone",
                    label: "(GMT+02:00) Gaborone"
                },
                {
                    id: "Africa/Harare",
                    label: "(GMT+02:00) Harare"
                },
                {
                    id: "Africa/Johannesburg",
                    label: "(GMT+02:00) Johannesburg"
                },
                {
                    id: "Africa/Juba",
                    label: "(GMT+02:00) Juba"
                },
                {
                    id: "Africa/Khartoum",
                    label: "(GMT+02:00) Khartoum"
                },
                {
                    id: "Africa/Kigali",
                    label: "(GMT+02:00) Kigali"
                },
                {
                    id: "Africa/Lubumbashi",
                    label: "(GMT+02:00) Lubumbashi"
                },
                {
                    id: "Africa/Lusaka",
                    label: "(GMT+02:00) Lusaka"
                },
                {
                    id: "Africa/Maputo",
                    label: "(GMT+02:00) Maputo"
                },
                {
                    id: "Africa/Maseru",
                    label: "(GMT+02:00) Maseru"
                },
                {
                    id: "Africa/Mbabane",
                    label: "(GMT+02:00) Mbabane"
                },
                {
                    id: "Africa/Tripoli",
                    label: "(GMT+02:00) Tripoli"
                },
                {
                    id: "Africa/Addis_Ababa",
                    label: "(GMT+03:00) Addis Ababa"
                },
                {
                    id: "Africa/Asmara",
                    label: "(GMT+03:00) Asmara"
                },
                {
                    id: "Africa/Dar_es_Salaam",
                    label: "(GMT+03:00) Dar es Salaam"
                },
                {
                    id: "Africa/Djibouti",
                    label: "(GMT+03:00) Djibouti"
                },
                {
                    id: "Africa/Kampala",
                    label: "(GMT+03:00) Kampala"
                },
                {
                    id: "Africa/Mogadishu",
                    label: "(GMT+03:00) Mogadishu"
                },
                {
                    id: "Africa/Nairobi",
                    label: "(GMT+03:00) Nairobi"
                }
            ]
        },
        {
            id: "America",
            label: "America",
            children: [
                {
                    id: "America/Adak",
                    label: "(GMT-10:00) Adak"
                },
                {
                    id: "America/Anchorage",
                    label: "(GMT-09:00) Anchorage"
                },
                {
                    id: "America/Juneau",
                    label: "(GMT-09:00) Juneau"
                },
                {
                    id: "America/Metlakatla",
                    label: "(GMT-09:00) Metlakatla"
                },
                {
                    id: "America/Nome",
                    label: "(GMT-09:00) Nome"
                },
                {
                    id: "America/Sitka",
                    label: "(GMT-09:00) Sitka"
                },
                {
                    id: "America/Yakutat",
                    label: "(GMT-09:00) Yakutat"
                },
                {
                    id: "America/Los_Angeles",
                    label: "(GMT-08:00) Los Angeles"
                },
                {
                    id: "America/Tijuana",
                    label: "(GMT-08:00) Tijuana"
                },
                {
                    id: "America/Vancouver",
                    label: "(GMT-08:00) Vancouver"
                },
                {
                    id: "America/Boise",
                    label: "(GMT-07:00) Boise"
                },
                {
                    id: "America/Cambridge_Bay",
                    label: "(GMT-07:00) Cambridge Bay"
                },
                {
                    id: "America/Chihuahua",
                    label: "(GMT-07:00) Chihuahua"
                },
                {
                    id: "America/Creston",
                    label: "(GMT-07:00) Creston"
                },
                {
                    id: "America/Dawson",
                    label: "(GMT-07:00) Dawson"
                },
                {
                    id: "America/Dawson_Creek",
                    label: "(GMT-07:00) Dawson Creek"
                },
                {
                    id: "America/Denver",
                    label: "(GMT-07:00) Denver"
                },
                {
                    id: "America/Edmonton",
                    label: "(GMT-07:00) Edmonton"
                },
                {
                    id: "America/Fort_Nelson",
                    label: "(GMT-07:00) Fort Nelson"
                },
                {
                    id: "America/Hermosillo",
                    label: "(GMT-07:00) Hermosillo"
                },
                {
                    id: "America/Inuvik",
                    label: "(GMT-07:00) Inuvik"
                },
                {
                    id: "America/Mazatlan",
                    label: "(GMT-07:00) Mazatlan"
                },
                {
                    id: "America/Ojinaga",
                    label: "(GMT-07:00) Ojinaga"
                },
                {
                    id: "America/Phoenix",
                    label: "(GMT-07:00) Phoenix"
                },
                {
                    id: "America/Whitehorse",
                    label: "(GMT-07:00) Whitehorse"
                },
                {
                    id: "America/Yellowknife",
                    label: "(GMT-07:00) Yellowknife"
                },
                {
                    id: "America/Bahia_Banderas",
                    label: "(GMT-06:00) Bahia Banderas"
                },
                {
                    id: "America/Belize",
                    label: "(GMT-06:00) Belize"
                },
                {
                    id: "America/Chicago",
                    label: "(GMT-06:00) Chicago"
                },
                {
                    id: "America/Costa_Rica",
                    label: "(GMT-06:00) Costa Rica"
                },
                {
                    id: "America/El_Salvador",
                    label: "(GMT-06:00) El Salvador"
                },
                {
                    id: "America/Guatemala",
                    label: "(GMT-06:00) Guatemala"
                },
                {
                    id: "America/Indiana/Knox",
                    label: "(GMT-06:00) Indiana / Knox"
                },
                {
                    id: "America/Indiana/Tell_City",
                    label: "(GMT-06:00) Indiana / Tell City"
                },
                {
                    id: "America/Managua",
                    label: "(GMT-06:00) Managua"
                },
                {
                    id: "America/Matamoros",
                    label: "(GMT-06:00) Matamoros"
                },
                {
                    id: "America/Menominee",
                    label: "(GMT-06:00) Menominee"
                },
                {
                    id: "America/Merida",
                    label: "(GMT-06:00) Merida"
                },
                {
                    id: "America/Mexico_City",
                    label: "(GMT-06:00) Mexico City"
                },
                {
                    id: "America/Monterrey",
                    label: "(GMT-06:00) Monterrey"
                },
                {
                    id: "America/North_Dakota/Beulah",
                    label: "(GMT-06:00) North Dakota / Beulah"
                },
                {
                    id: "America/North_Dakota/Center",
                    label: "(GMT-06:00) North Dakota / Center"
                },
                {
                    id: "America/North_Dakota/New_Salem",
                    label: "(GMT-06:00) North Dakota / New Salem"
                },
                {
                    id: "America/Rainy_River",
                    label: "(GMT-06:00) Rainy River"
                },
                {
                    id: "America/Rankin_Inlet",
                    label: "(GMT-06:00) Rankin Inlet"
                },
                {
                    id: "America/Regina",
                    label: "(GMT-06:00) Regina"
                },
                {
                    id: "America/Resolute",
                    label: "(GMT-06:00) Resolute"
                },
                {
                    id: "America/Swift_Current",
                    label: "(GMT-06:00) Swift Current"
                },
                {
                    id: "America/Tegucigalpa",
                    label: "(GMT-06:00) Tegucigalpa"
                },
                {
                    id: "America/Winnipeg",
                    label: "(GMT-06:00) Winnipeg"
                },
                {
                    id: "America/Atikokan",
                    label: "(GMT-05:00) Atikokan"
                },
                {
                    id: "America/Bogota",
                    label: "(GMT-05:00) Bogota"
                },
                {
                    id: "America/Cancun",
                    label: "(GMT-05:00) Cancun"
                },
                {
                    id: "America/Cayman",
                    label: "(GMT-05:00) Cayman"
                },
                {
                    id: "America/Detroit",
                    label: "(GMT-05:00) Detroit"
                },
                {
                    id: "America/Eirunepe",
                    label: "(GMT-05:00) Eirunepe"
                },
                {
                    id: "America/Grand_Turk",
                    label: "(GMT-05:00) Grand Turk"
                },
                {
                    id: "America/Guayaquil",
                    label: "(GMT-05:00) Guayaquil"
                },
                {
                    id: "America/Havana",
                    label: "(GMT-05:00) Havana"
                },
                {
                    id: "America/Indiana/Indianapolis",
                    label: "(GMT-05:00) Indiana / Indianapolis"
                },
                {
                    id: "America/Indiana/Marengo",
                    label: "(GMT-05:00) Indiana / Marengo"
                },
                {
                    id: "America/Indiana/Petersburg",
                    label: "(GMT-05:00) Indiana / Petersburg"
                },
                {
                    id: "America/Indiana/Vevay",
                    label: "(GMT-05:00) Indiana / Vevay"
                },
                {
                    id: "America/Indiana/Vincennes",
                    label: "(GMT-05:00) Indiana / Vincennes"
                },
                {
                    id: "America/Indiana/Winamac",
                    label: "(GMT-05:00) Indiana / Winamac"
                },
                {
                    id: "America/Iqaluit",
                    label: "(GMT-05:00) Iqaluit"
                },
                {
                    id: "America/Jamaica",
                    label: "(GMT-05:00) Jamaica"
                },
                {
                    id: "America/Kentucky/Louisville",
                    label: "(GMT-05:00) Kentucky / Louisville"
                },
                {
                    id: "America/Kentucky/Monticello",
                    label: "(GMT-05:00) Kentucky / Monticello"
                },
                {
                    id: "America/Lima",
                    label: "(GMT-05:00) Lima"
                },
                {
                    id: "America/Nassau",
                    label: "(GMT-05:00) Nassau"
                },
                {
                    id: "America/New_York",
                    label: "(GMT-05:00) New York"
                },
                {
                    id: "America/Nipigon",
                    label: "(GMT-05:00) Nipigon"
                },
                {
                    id: "America/Panama",
                    label: "(GMT-05:00) Panama"
                },
                {
                    id: "America/Pangnirtung",
                    label: "(GMT-05:00) Pangnirtung"
                },
                {
                    id: "America/Port-au-Prince",
                    label: "(GMT-05:00) Port-au-Prince"
                },
                {
                    id: "America/Rio_Branco",
                    label: "(GMT-05:00) Rio Branco"
                },
                {
                    id: "America/Thunder_Bay",
                    label: "(GMT-05:00) Thunder Bay"
                },
                {
                    id: "America/Toronto",
                    label: "(GMT-05:00) Toronto"
                },
                {
                    id: "America/Anguilla",
                    label: "(GMT-04:00) Anguilla"
                },
                {
                    id: "America/Antigua",
                    label: "(GMT-04:00) Antigua"
                },
                {
                    id: "America/Aruba",
                    label: "(GMT-04:00) Aruba"
                },
                {
                    id: "America/Asuncion",
                    label: "(GMT-04:00) Asuncion"
                },
                {
                    id: "America/Barbados",
                    label: "(GMT-04:00) Barbados"
                },
                {
                    id: "America/Blanc-Sablon",
                    label: "(GMT-04:00) Blanc-Sablon"
                },
                {
                    id: "America/Boa_Vista",
                    label: "(GMT-04:00) Boa Vista"
                },
                {
                    id: "America/Campo_Grande",
                    label: "(GMT-04:00) Campo Grande"
                },
                {
                    id: "America/Caracas",
                    label: "(GMT-04:00) Caracas"
                },
                {
                    id: "America/Cuiaba",
                    label: "(GMT-04:00) Cuiaba"
                },
                {
                    id: "America/Curacao",
                    label: "(GMT-04:00) Curacao"
                },
                {
                    id: "America/Dominica",
                    label: "(GMT-04:00) Dominica"
                },
                {
                    id: "America/Glace_Bay",
                    label: "(GMT-04:00) Glace Bay"
                },
                {
                    id: "America/Goose_Bay",
                    label: "(GMT-04:00) Goose Bay"
                },
                {
                    id: "America/Grenada",
                    label: "(GMT-04:00) Grenada"
                },
                {
                    id: "America/Guadeloupe",
                    label: "(GMT-04:00) Guadeloupe"
                },
                {
                    id: "America/Guyana",
                    label: "(GMT-04:00) Guyana"
                },
                {
                    id: "America/Halifax",
                    label: "(GMT-04:00) Halifax"
                },
                {
                    id: "America/Kralendijk",
                    label: "(GMT-04:00) Kralendijk"
                },
                {
                    id: "America/La_Paz",
                    label: "(GMT-04:00) La Paz"
                },
                {
                    id: "America/Lower_Princes",
                    label: "(GMT-04:00) Lower Princes"
                },
                {
                    id: "America/Manaus",
                    label: "(GMT-04:00) Manaus"
                },
                {
                    id: "America/Marigot",
                    label: "(GMT-04:00) Marigot"
                },
                {
                    id: "America/Martinique",
                    label: "(GMT-04:00) Martinique"
                },
                {
                    id: "America/Moncton",
                    label: "(GMT-04:00) Moncton"
                },
                {
                    id: "America/Montserrat",
                    label: "(GMT-04:00) Montserrat"
                },
                {
                    id: "America/Port_of_Spain",
                    label: "(GMT-04:00) Port of Spain"
                },
                {
                    id: "America/Porto_Velho",
                    label: "(GMT-04:00) Porto Velho"
                },
                {
                    id: "America/Puerto_Rico",
                    label: "(GMT-04:00) Puerto Rico"
                },
                {
                    id: "America/Santiago",
                    label: "(GMT-04:00) Santiago"
                },
                {
                    id: "America/Santo_Domingo",
                    label: "(GMT-04:00) Santo Domingo"
                },
                {
                    id: "America/St_Barthelemy",
                    label: "(GMT-04:00) St Barthelemy"
                },
                {
                    id: "America/St_Kitts",
                    label: "(GMT-04:00) St Kitts"
                },
                {
                    id: "America/St_Lucia",
                    label: "(GMT-04:00) St Lucia"
                },
                {
                    id: "America/St_Thomas",
                    label: "(GMT-04:00) St Thomas"
                },
                {
                    id: "America/St_Vincent",
                    label: "(GMT-04:00) St Vincent"
                },
                {
                    id: "America/Thule",
                    label: "(GMT-04:00) Thule"
                },
                {
                    id: "America/Tortola",
                    label: "(GMT-04:00) Tortola"
                },
                {
                    id: "America/St_Johns",
                    label: "(GMT-03:30) St Johns"
                },
                {
                    id: "America/Araguaina",
                    label: "(GMT-03:00) Araguaina"
                },
                {
                    id: "America/Argentina/Buenos_Aires",
                    label: "(GMT-03:00) Argentina / Buenos Aires"
                },
                {
                    id: "America/Argentina/Catamarca",
                    label: "(GMT-03:00) Argentina / Catamarca"
                },
                {
                    id: "America/Argentina/Cordoba",
                    label: "(GMT-03:00) Argentina / Cordoba"
                },
                {
                    id: "America/Argentina/Jujuy",
                    label: "(GMT-03:00) Argentina / Jujuy"
                },
                {
                    id: "America/Argentina/La_Rioja",
                    label: "(GMT-03:00) Argentina / La Rioja"
                },
                {
                    id: "America/Argentina/Mendoza",
                    label: "(GMT-03:00) Argentina / Mendoza"
                },
                {
                    id: "America/Argentina/Rio_Gallegos",
                    label: "(GMT-03:00) Argentina / Rio Gallegos"
                },
                {
                    id: "America/Argentina/Salta",
                    label: "(GMT-03:00) Argentina / Salta"
                },
                {
                    id: "America/Argentina/San_Juan",
                    label: "(GMT-03:00) Argentina / San Juan"
                },
                {
                    id: "America/Argentina/San_Luis",
                    label: "(GMT-03:00) Argentina / San Luis"
                },
                {
                    id: "America/Argentina/Tucuman",
                    label: "(GMT-03:00) Argentina / Tucuman"
                },
                {
                    id: "America/Argentina/Ushuaia",
                    label: "(GMT-03:00) Argentina / Ushuaia"
                },
                {
                    id: "America/Bahia",
                    label: "(GMT-03:00) Bahia"
                },
                {
                    id: "America/Belem",
                    label: "(GMT-03:00) Belem"
                },
                {
                    id: "America/Cayenne",
                    label: "(GMT-03:00) Cayenne"
                },
                {
                    id: "America/Fortaleza",
                    label: "(GMT-03:00) Fortaleza"
                },
                {
                    id: "America/Godthab",
                    label: "(GMT-03:00) Godthab"
                },
                {
                    id: "America/Maceio",
                    label: "(GMT-03:00) Maceio"
                },
                {
                    id: "America/Miquelon",
                    label: "(GMT-03:00) Miquelon"
                },
                {
                    id: "America/Montevideo",
                    label: "(GMT-03:00) Montevideo"
                },
                {
                    id: "America/Paramaribo",
                    label: "(GMT-03:00) Paramaribo"
                },
                {
                    id: "America/Punta_Arenas",
                    label: "(GMT-03:00) Punta Arenas"
                },
                {
                    id: "America/Recife",
                    label: "(GMT-03:00) Recife"
                },
                {
                    id: "America/Santarem",
                    label: "(GMT-03:00) Santarem"
                },
                {
                    id: "America/Sao_Paulo",
                    label: "(GMT-03:00) Sao Paulo"
                },
                {
                    id: "America/Noronha",
                    label: "(GMT-02:00) Noronha"
                },
                {
                    id: "America/Scoresbysund",
                    label: "(GMT-01:00) Scoresbysund"
                },
                {
                    id: "America/Danmarkshavn",
                    label: "(GMT+00:00) Danmarkshavn"
                }
            ]
        },
        {
            id: "Antarctica",
            label: "Antarctica",
            children: [
                {
                    id: "Antarctica/Palmer",
                    label: "(GMT-03:00) Palmer"
                },
                {
                    id: "Antarctica/Rothera",
                    label: "(GMT-03:00) Rothera"
                },
                {
                    id: "Antarctica/Troll",
                    label: "(GMT+00:00) Troll"
                },
                {
                    id: "Antarctica/Syowa",
                    label: "(GMT+03:00) Syowa"
                },
                {
                    id: "Antarctica/Mawson",
                    label: "(GMT+05:00) Mawson"
                },
                {
                    id: "Antarctica/Vostok",
                    label: "(GMT+06:00) Vostok"
                },
                {
                    id: "Antarctica/Davis",
                    label: "(GMT+07:00) Davis"
                },
                {
                    id: "Antarctica/DumontDUrville",
                    label: "(GMT+10:00) Dumont d'Urville"
                },
                {
                    id: "Antarctica/Macquarie",
                    label: "(GMT+10:00) Macquarie"
                },
                {
                    id: "Antarctica/Casey",
                    label: "(GMT+11:00) Casey"
                },
                {
                    id: "Antarctica/McMurdo",
                    label: "(GMT+12:00) McMurdo"
                }
            ]
        },
        {
            id: "Asia",
            label: "Asia",
            children: [
                {
                    id: "Asia/Amman",
                    label: "(GMT+02:00) Amman"
                },
                {
                    id: "Asia/Beirut",
                    label: "(GMT+02:00) Beirut"
                },
                {
                    id: "Asia/Damascus",
                    label: "(GMT+02:00) Damascus"
                },
                {
                    id: "Asia/Famagusta",
                    label: "(GMT+02:00) Famagusta"
                },
                {
                    id: "Asia/Gaza",
                    label: "(GMT+02:00) Gaza"
                },
                {
                    id: "Asia/Hebron",
                    label: "(GMT+02:00) Hebron"
                },
                {
                    id: "Asia/Jerusalem",
                    label: "(GMT+02:00) Jerusalem"
                },
                {
                    id: "Asia/Nicosia",
                    label: "(GMT+02:00) Nicosia"
                },
                {
                    id: "Asia/Aden",
                    label: "(GMT+03:00) Aden"
                },
                {
                    id: "Asia/Baghdad",
                    label: "(GMT+03:00) Baghdad"
                },
                {
                    id: "Asia/Bahrain",
                    label: "(GMT+03:00) Bahrain"
                },
                {
                    id: "Asia/Istanbul",
                    label: "(GMT+03:00) Istanbul"
                },
                {
                    id: "Asia/Kuwait",
                    label: "(GMT+03:00) Kuwait"
                },
                {
                    id: "Asia/Qatar",
                    label: "(GMT+03:00) Qatar"
                },
                {
                    id: "Asia/Riyadh",
                    label: "(GMT+03:00) Riyadh"
                },
                {
                    id: "Asia/Tehran",
                    label: "(GMT+03:30) Tehran"
                },
                {
                    id: "Asia/Baku",
                    label: "(GMT+04:00) Baku"
                },
                {
                    id: "Asia/Dubai",
                    label: "(GMT+04:00) Dubai"
                },
                {
                    id: "Asia/Muscat",
                    label: "(GMT+04:00) Muscat"
                },
                {
                    id: "Asia/Tbilisi",
                    label: "(GMT+04:00) Tbilisi"
                },
                {
                    id: "Asia/Yerevan",
                    label: "(GMT+04:00) Yerevan"
                },
                {
                    id: "Asia/Kabul",
                    label: "(GMT+04:30) Kabul"
                },
                {
                    id: "Asia/Aqtau",
                    label: "(GMT+05:00) Aqtau"
                },
                {
                    id: "Asia/Aqtobe",
                    label: "(GMT+05:00) Aqtobe"
                },
                {
                    id: "Asia/Ashgabat",
                    label: "(GMT+05:00) Ashgabat"
                },
                {
                    id: "Asia/Atyrau",
                    label: "(GMT+05:00) Atyrau"
                },
                {
                    id: "Asia/Dushanbe",
                    label: "(GMT+05:00) Dushanbe"
                },
                {
                    id: "Asia/Karachi",
                    label: "(GMT+05:00) Karachi"
                },
                {
                    id: "Asia/Oral",
                    label: "(GMT+05:00) Oral"
                },
                {
                    id: "Asia/Qyzylorda",
                    label: "(GMT+05:00) Qyzylorda"
                },
                {
                    id: "Asia/Samarkand",
                    label: "(GMT+05:00) Samarkand"
                },
                {
                    id: "Asia/Tashkent",
                    label: "(GMT+05:00) Tashkent"
                },
                {
                    id: "Asia/Yekaterinburg",
                    label: "(GMT+05:00) Yekaterinburg"
                },
                {
                    id: "Asia/Colombo",
                    label: "(GMT+05:30) Colombo"
                },
                {
                    id: "Asia/Kolkata",
                    label: "(GMT+05:30) Kolkata"
                },
                {
                    id: "Asia/Kathmandu",
                    label: "(GMT+05:45) Kathmandu"
                },
                {
                    id: "Asia/Almaty",
                    label: "(GMT+06:00) Almaty"
                },
                {
                    id: "Asia/Bishkek",
                    label: "(GMT+06:00) Bishkek"
                },
                {
                    id: "Asia/Dhaka",
                    label: "(GMT+06:00) Dhaka"
                },
                {
                    id: "Asia/Omsk",
                    label: "(GMT+06:00) Omsk"
                },
                {
                    id: "Asia/Qostanay",
                    label: "(GMT+06:00) Qostanay"
                },
                {
                    id: "Asia/Thimphu",
                    label: "(GMT+06:00) Thimphu"
                },
                {
                    id: "Asia/Urumqi",
                    label: "(GMT+06:00) Urumqi"
                },
                {
                    id: "Asia/Yangon",
                    label: "(GMT+06:30) Yangon"
                },
                {
                    id: "Asia/Bangkok",
                    label: "(GMT+07:00) Bangkok"
                },
                {
                    id: "Asia/Barnaul",
                    label: "(GMT+07:00) Barnaul"
                },
                {
                    id: "Asia/Ho_Chi_Minh",
                    label: "(GMT+07:00) Ho Chi Minh"
                },
                {
                    id: "Asia/Hovd",
                    label: "(GMT+07:00) Hovd"
                },
                {
                    id: "Asia/Jakarta",
                    label: "(GMT+07:00) Jakarta"
                },
                {
                    id: "Asia/Krasnoyarsk",
                    label: "(GMT+07:00) Krasnoyarsk"
                },
                {
                    id: "Asia/Novokuznetsk",
                    label: "(GMT+07:00) Novokuznetsk"
                },
                {
                    id: "Asia/Novosibirsk",
                    label: "(GMT+07:00) Novosibirsk"
                },
                {
                    id: "Asia/Phnom_Penh",
                    label: "(GMT+07:00) Phnom Penh"
                },
                {
                    id: "Asia/Pontianak",
                    label: "(GMT+07:00) Pontianak"
                },
                {
                    id: "Asia/Tomsk",
                    label: "(GMT+07:00) Tomsk"
                },
                {
                    id: "Asia/Vientiane",
                    label: "(GMT+07:00) Vientiane"
                },
                {
                    id: "Asia/Brunei",
                    label: "(GMT+08:00) Brunei"
                },
                {
                    id: "Asia/Choibalsan",
                    label: "(GMT+08:00) Choibalsan"
                },
                {
                    id: "Asia/Hong_Kong",
                    label: "(GMT+08:00) Hong Kong"
                },
                {
                    id: "Asia/Irkutsk",
                    label: "(GMT+08:00) Irkutsk"
                },
                {
                    id: "Asia/Kuala_Lumpur",
                    label: "(GMT+08:00) Kuala Lumpur"
                },
                {
                    id: "Asia/Kuching",
                    label: "(GMT+08:00) Kuching"
                },
                {
                    id: "Asia/Macau",
                    label: "(GMT+08:00) Macau"
                },
                {
                    id: "Asia/Makassar",
                    label: "(GMT+08:00) Makassar"
                },
                {
                    id: "Asia/Manila",
                    label: "(GMT+08:00) Manila"
                },
                {
                    id: "Asia/Shanghai",
                    label: "(GMT+08:00) Shanghai"
                },
                {
                    id: "Asia/Singapore",
                    label: "(GMT+08:00) Singapore"
                },
                {
                    id: "Asia/Taipei",
                    label: "(GMT+08:00) Taipei"
                },
                {
                    id: "Asia/Ulaanbaatar",
                    label: "(GMT+08:00) Ulaanbaatar"
                },
                {
                    id: "Asia/Chita",
                    label: "(GMT+09:00) Chita"
                },
                {
                    id: "Asia/Dili",
                    label: "(GMT+09:00) Dili"
                },
                {
                    id: "Asia/Jayapura",
                    label: "(GMT+09:00) Jayapura"
                },
                {
                    id: "Asia/Khandyga",
                    label: "(GMT+09:00) Khandyga"
                },
                {
                    id: "Asia/Pyongyang",
                    label: "(GMT+09:00) Pyongyang"
                },
                {
                    id: "Asia/Seoul",
                    label: "(GMT+09:00) Seoul"
                },
                {
                    id: "Asia/Tokyo",
                    label: "(GMT+09:00) Tokyo"
                },
                {
                    id: "Asia/Yakutsk",
                    label: "(GMT+09:00) Yakutsk"
                },
                {
                    id: "Asia/Ust-Nera",
                    label: "(GMT+10:00) Ust-Nera"
                },
                {
                    id: "Asia/Vladivostok",
                    label: "(GMT+10:00) Vladivostok"
                },
                {
                    id: "Asia/Magadan",
                    label: "(GMT+11:00) Magadan"
                },
                {
                    id: "Asia/Sakhalin",
                    label: "(GMT+11:00) Sakhalin"
                },
                {
                    id: "Asia/Srednekolymsk",
                    label: "(GMT+11:00) Srednekolymsk"
                },
                {
                    id: "Asia/Anadyr",
                    label: "(GMT+12:00) Anadyr"
                },
                {
                    id: "Asia/Kamchatka",
                    label: "(GMT+12:00) Kamchatka"
                }
            ]
        },
        {
            id: "Atlantic",
            label: "Atlantic",
            children: [
                {
                    id: "Atlantic/Bermuda",
                    label: "(GMT-04:00) Bermuda"
                },
                {
                    id: "Atlantic/Stanley",
                    label: "(GMT-03:00) Stanley"
                },
                {
                    id: "Atlantic/South_Georgia",
                    label: "(GMT-02:00) South Georgia"
                },
                {
                    id: "Atlantic/Azores",
                    label: "(GMT-01:00) Azores"
                },
                {
                    id: "Atlantic/Cape_Verde",
                    label: "(GMT-01:00) Cape Verde"
                },
                {
                    id: "Atlantic/Canary",
                    label: "(GMT+00:00) Canary"
                },
                {
                    id: "Atlantic/Faroe",
                    label: "(GMT+00:00) Faroe"
                },
                {
                    id: "Atlantic/Madeira",
                    label: "(GMT+00:00) Madeira"
                },
                {
                    id: "Atlantic/Reykjavik",
                    label: "(GMT+00:00) Reykjavik"
                },
                {
                    id: "Atlantic/St_Helena",
                    label: "(GMT+00:00) St Helena"
                }
            ]
        },
        {
            id: "Australia",
            label: "Australia",
            children: [
                {
                    id: "Australia/Perth",
                    label: "(GMT+08:00) Perth"
                },
                {
                    id: "Australia/Eucla",
                    label: "(GMT+08:45) Eucla"
                },
                {
                    id: "Australia/Adelaide",
                    label: "(GMT+09:30) Adelaide"
                },
                {
                    id: "Australia/Broken_Hill",
                    label: "(GMT+09:30) Broken Hill"
                },
                {
                    id: "Australia/Darwin",
                    label: "(GMT+09:30) Darwin"
                },
                {
                    id: "Australia/Brisbane",
                    label: "(GMT+10:00) Brisbane"
                },
                {
                    id: "Australia/Currie",
                    label: "(GMT+10:00) Currie"
                },
                {
                    id: "Australia/Hobart",
                    label: "(GMT+10:00) Hobart"
                },
                {
                    id: "Australia/Lindeman",
                    label: "(GMT+10:00) Lindeman"
                },
                {
                    id: "Australia/Melbourne",
                    label: "(GMT+10:00) Melbourne"
                },
                {
                    id: "Australia/Sydney",
                    label: "(GMT+10:00) Sydney"
                },
                {
                    id: "Australia/Lord_Howe",
                    label: "(GMT+10:30) Lord Howe"
                }
            ]
        },
        {
            id: "Europe",
            label: "Europe",
            children: [
                {
                    id: "Europe/Dublin",
                    label: "(GMT+00:00) Dublin"
                },
                {
                    id: "Europe/Guernsey",
                    label: "(GMT+00:00) Guernsey"
                },
                {
                    id: "Europe/Isle_of_Man",
                    label: "(GMT+00:00) Isle of Man"
                },
                {
                    id: "Europe/Jersey",
                    label: "(GMT+00:00) Jersey"
                },
                {
                    id: "Europe/Lisbon",
                    label: "(GMT+00:00) Lisbon"
                },
                {
                    id: "Europe/London",
                    label: "(GMT+00:00) London"
                },
                {
                    id: "Europe/Amsterdam",
                    label: "(GMT+01:00) Amsterdam"
                },
                {
                    id: "Europe/Andorra",
                    label: "(GMT+01:00) Andorra"
                },
                {
                    id: "Europe/Belgrade",
                    label: "(GMT+01:00) Belgrade"
                },
                {
                    id: "Europe/Berlin",
                    label: "(GMT+01:00) Berlin"
                },
                {
                    id: "Europe/Bratislava",
                    label: "(GMT+01:00) Bratislava"
                },
                {
                    id: "Europe/Brussels",
                    label: "(GMT+01:00) Brussels"
                },
                {
                    id: "Europe/Budapest",
                    label: "(GMT+01:00) Budapest"
                },
                {
                    id: "Europe/Busingen",
                    label: "(GMT+01:00) Busingen"
                },
                {
                    id: "Europe/Copenhagen",
                    label: "(GMT+01:00) Copenhagen"
                },
                {
                    id: "Europe/Gibraltar",
                    label: "(GMT+01:00) Gibraltar"
                },
                {
                    id: "Europe/Ljubljana",
                    label: "(GMT+01:00) Ljubljana"
                },
                {
                    id: "Europe/Luxembourg",
                    label: "(GMT+01:00) Luxembourg"
                },
                {
                    id: "Europe/Madrid",
                    label: "(GMT+01:00) Madrid"
                },
                {
                    id: "Europe/Malta",
                    label: "(GMT+01:00) Malta"
                },
                {
                    id: "Europe/Monaco",
                    label: "(GMT+01:00) Monaco"
                },
                {
                    id: "Europe/Oslo",
                    label: "(GMT+01:00) Oslo"
                },
                {
                    id: "Europe/Paris",
                    label: "(GMT+01:00) Paris"
                },
                {
                    id: "Europe/Podgorica",
                    label: "(GMT+01:00) Podgorica"
                },
                {
                    id: "Europe/Prague",
                    label: "(GMT+01:00) Prague"
                },
                {
                    id: "Europe/Rome",
                    label: "(GMT+01:00) Rome"
                },
                {
                    id: "Europe/San_Marino",
                    label: "(GMT+01:00) San Marino"
                },
                {
                    id: "Europe/Sarajevo",
                    label: "(GMT+01:00) Sarajevo"
                },
                {
                    id: "Europe/Skopje",
                    label: "(GMT+01:00) Skopje"
                },
                {
                    id: "Europe/Stockholm",
                    label: "(GMT+01:00) Stockholm"
                },
                {
                    id: "Europe/Tirane",
                    label: "(GMT+01:00) Tirane"
                },
                {
                    id: "Europe/Vaduz",
                    label: "(GMT+01:00) Vaduz"
                },
                {
                    id: "Europe/Vatican",
                    label: "(GMT+01:00) Vatican"
                },
                {
                    id: "Europe/Vienna",
                    label: "(GMT+01:00) Vienna"
                },
                {
                    id: "Europe/Warsaw",
                    label: "(GMT+01:00) Warsaw"
                },
                {
                    id: "Europe/Zagreb",
                    label: "(GMT+01:00) Zagreb"
                },
                {
                    id: "Europe/Zurich",
                    label: "(GMT+01:00) Zurich"
                },
                {
                    id: "Europe/Athens",
                    label: "(GMT+02:00) Athens"
                },
                {
                    id: "Europe/Bucharest",
                    label: "(GMT+02:00) Bucharest"
                },
                {
                    id: "Europe/Chisinau",
                    label: "(GMT+02:00) Chisinau"
                },
                {
                    id: "Europe/Helsinki",
                    label: "(GMT+02:00) Helsinki"
                },
                {
                    id: "Europe/Kaliningrad",
                    label: "(GMT+02:00) Kaliningrad"
                },
                {
                    id: "Europe/Kiev",
                    label: "(GMT+02:00) Kiev"
                },
                {
                    id: "Europe/Mariehamn",
                    label: "(GMT+02:00) Mariehamn"
                },
                {
                    id: "Europe/Nicosia",
                    label: "(GMT+02:00) Nicosia"
                },
                {
                    id: "Europe/Riga",
                    label: "(GMT+02:00) Riga"
                },
                {
                    id: "Europe/Sofia",
                    label: "(GMT+02:00) Sofia"
                },
                {
                    id: "Europe/Tallinn",
                    label: "(GMT+02:00) Tallinn"
                },
                {
                    id: "Europe/Uzhgorod",
                    label: "(GMT+02:00) Uzhgorod"
                },
                {
                    id: "Europe/Vilnius",
                    label: "(GMT+02:00) Vilnius"
                },
                {
                    id: "Europe/Zaporozhye",
                    label: "(GMT+02:00) Zaporozhye"
                },
                {
                    id: "Europe/Istanbul",
                    label: "(GMT+03:00) Istanbul"
                },
                {
                    id: "Europe/Kirov",
                    label: "(GMT+03:00) Kirov"
                },
                {
                    id: "Europe/Minsk",
                    label: "(GMT+03:00) Minsk"
                },
                {
                    id: "Europe/Moscow",
                    label: "(GMT+03:00) Moscow"
                },
                {
                    id: "Europe/Simferopol",
                    label: "(GMT+03:00) Simferopol"
                },
                {
                    id: "Europe/Volgograd",
                    label: "(GMT+03:00) Volgograd"
                },
                {
                    id: "Europe/Astrakhan",
                    label: "(GMT+04:00) Astrakhan"
                },
                {
                    id: "Europe/Samara",
                    label: "(GMT+04:00) Samara"
                },
                {
                    id: "Europe/Saratov",
                    label: "(GMT+04:00) Saratov"
                },
                {
                    id: "Europe/Ulyanovsk",
                    label: "(GMT+04:00) Ulyanovsk"
                }
            ]
        },
        {
            id: "Etc",
            label: "Etc",
            children: [
                {
                    id: "Etc/GMT+12",
                    label: "(GMT-12:00) GMT-12"
                },
                {
                    id: "Etc/GMT+11",
                    label: "(GMT-11:00) GMT-11"
                },
                {
                    id: "Etc/GMT+10",
                    label: "(GMT-10:00) GMT-10"
                },
                {
                    id: "Etc/GMT+9",
                    label: "(GMT-09:00) GMT-9"
                },
                {
                    id: "Etc/GMT+8",
                    label: "(GMT-08:00) GMT-8"
                },
                {
                    id: "Etc/GMT+7",
                    label: "(GMT-07:00) GMT-7"
                },
                {
                    id: "Etc/GMT+6",
                    label: "(GMT-06:00) GMT-6"
                },
                {
                    id: "Etc/GMT+5",
                    label: "(GMT-05:00) GMT-5"
                },
                {
                    id: "Etc/GMT+4",
                    label: "(GMT-04:00) GMT-4"
                },
                {
                    id: "Etc/GMT+3",
                    label: "(GMT-03:00) GMT-3"
                },
                {
                    id: "Etc/GMT+2",
                    label: "(GMT-02:00) GMT-2"
                },
                {
                    id: "Etc/GMT+1",
                    label: "(GMT-01:00) GMT-1"
                },
                {
                    id: "Etc/GMT",
                    label: "(GMT+00:00) GMT"
                },
                {
                    id: "Etc/GMT-1",
                    label: "(GMT+01:00) GMT+1"
                },
                {
                    id: "Etc/GMT-2",
                    label: "(GMT+02:00) GMT+2"
                },
                {
                    id: "Etc/GMT-3",
                    label: "(GMT+03:00) GMT+3"
                },
                {
                    id: "Etc/GMT-4",
                    label: "(GMT+04:00) GMT+4"
                },
                {
                    id: "Etc/GMT-5",
                    label: "(GMT+05:00) GMT+5"
                },
                {
                    id: "Etc/GMT-6",
                    label: "(GMT+06:00) GMT+6"
                },
                {
                    id: "Etc/GMT-7",
                    label: "(GMT+07:00) GMT+7"
                },
                {
                    id: "Etc/GMT-8",
                    label: "(GMT+08:00) GMT+8"
                },
                {
                    id: "Etc/GMT-9",
                    label: "(GMT+09:00) GMT+9"
                },
                {
                    id: "Etc/GMT-10",
                    label: "(GMT+10:00) GMT+10"
                },
                {
                    id: "Etc/GMT-11",
                    label: "(GMT+11:00) GMT+11"
                },
                {
                    id: "Etc/GMT-12",
                    label: "(GMT+12:00) GMT+12"
                },
                {
                    id: "Etc/GMT-13",
                    label: "(GMT+13:00) GMT+13"
                },
                {
                    id: "Etc/GMT-14",
                    label: "(GMT+14:00) GMT+14"
                }
            ]
        },
        {
            id: "Indian",
            label: "Indian",
            children: [
                {
                    id: "Indian/Antananarivo",
                    label: "(GMT+03:00) Antananarivo"
                },
                {
                    id: "Indian/Comoro",
                    label: "(GMT+03:00) Comoro"
                },
                {
                    id: "Indian/Mayotte",
                    label: "(GMT+03:00) Mayotte"
                },
                {
                    id: "Indian/Mahe",
                    label: "(GMT+04:00) Mahe"
                },
                {
                    id: "Indian/Mauritius",
                    label: "(GMT+04:00) Mauritius"
                },
                {
                    id: "Indian/Reunion",
                    label: "(GMT+04:00) Reunion"
                },
                {
                    id: "Indian/Kerguelen",
                    label: "(GMT+05:00) Kerguelen"
                },
                {
                    id: "Indian/Maldives",
                    label: "(GMT+05:00) Maldives"
                },
                {
                    id: "Indian/Chagos",
                    label: "(GMT+06:00) Chagos"
                },
                {
                    id: "Indian/Cocos",
                    label: "(GMT+06:30) Cocos"
                },
                {
                    id: "Indian/Christmas",
                    label: "(GMT+07:00) Christmas"
                }
            ]
        },
        {
            id: "Pacific",
            label: "Pacific",
            children: [
                {
                    id: "Pacific/Midway",
                    label: "(GMT-11:00) Midway"
                },
                {
                    id: "Pacific/Niue",
                    label: "(GMT-11:00) Niue"
                },
                {
                    id: "Pacific/Pago_Pago",
                    label: "(GMT-11:00) Pago Pago"
                },
                {
                    id: "Pacific/Honolulu",
                    label: "(GMT-10:00) Honolulu"
                },
                {
                    id: "Pacific/Rarotonga",
                    label: "(GMT-10:00) Rarotonga"
                },
                {
                    id: "Pacific/Tahiti",
                    label: "(GMT-10:00) Tahiti"
                },
                {
                    id: "Pacific/Marquesas",
                    label: "(GMT-09:30) Marquesas"
                },
                {
                    id: "Pacific/Gambier",
                    label: "(GMT-09:00) Gambier"
                },
                {
                    id: "Pacific/Pitcairn",
                    label: "(GMT-08:00) Pitcairn"
                },
                {
                    id: "Pacific/Easter",
                    label: "(GMT-06:00) Easter"
                },
                {
                    id: "Pacific/Galapagos",
                    label: "(GMT-06:00) Galapagos"
                },
                {
                    id: "Pacific/Palau",
                    label: "(GMT+09:00) Palau"
                },
                {
                    id: "Pacific/Chuuk",
                    label: "(GMT+10:00) Chuuk"
                },
                {
                    id: "Pacific/Guam",
                    label: "(GMT+10:00) Guam"
                },
                {
                    id: "Pacific/Port_Moresby",
                    label: "(GMT+10:00) Port Moresby"
                },
                {
                    id: "Pacific/Saipan",
                    label: "(GMT+10:00) Saipan"
                },
                {
                    id: "Pacific/Bougainville",
                    label: "(GMT+11:00) Bougainville"
                },
                {
                    id: "Pacific/Efate",
                    label: "(GMT+11:00) Efate"
                },
                {
                    id: "Pacific/Guadalcanal",
                    label: "(GMT+11:00) Guadalcanal"
                },
                {
                    id: "Pacific/Kosrae",
                    label: "(GMT+11:00) Kosrae"
                },
                {
                    id: "Pacific/Norfolk",
                    label: "(GMT+11:00) Norfolk"
                },
                {
                    id: "Pacific/Noumea",
                    label: "(GMT+11:00) Noumea"
                },
                {
                    id: "Pacific/Pohnpei",
                    label: "(GMT+11:00) Pohnpei"
                },
                {
                    id: "Pacific/Auckland",
                    label: "(GMT+12:00) Auckland"
                },
                {
                    id: "Pacific/Fiji",
                    label: "(GMT+12:00) Fiji"
                },
                {
                    id: "Pacific/Funafuti",
                    label: "(GMT+12:00) Funafuti"
                },
                {
                    id: "Pacific/Kwajalein",
                    label: "(GMT+12:00) Kwajalein"
                },
                {
                    id: "Pacific/Majuro",
                    label: "(GMT+12:00) Majuro"
                },
                {
                    id: "Pacific/Nauru",
                    label: "(GMT+12:00) Nauru"
                },
                {
                    id: "Pacific/Tarawa",
                    label: "(GMT+12:00) Tarawa"
                },
                {
                    id: "Pacific/Wake",
                    label: "(GMT+12:00) Wake"
                },
                {
                    id: "Pacific/Wallis",
                    label: "(GMT+12:00) Wallis"
                },
                {
                    id: "Pacific/Chatham",
                    label: "(GMT+12:45) Chatham"
                },
                {
                    id: "Pacific/Apia",
                    label: "(GMT+13:00) Apia"
                },
                {
                    id: "Pacific/Enderbury",
                    label: "(GMT+13:00) Enderbury"
                },
                {
                    id: "Pacific/Fakaofo",
                    label: "(GMT+13:00) Fakaofo"
                },
                {
                    id: "Pacific/Tongatapu",
                    label: "(GMT+13:00) Tongatapu"
                },
                {
                    id: "Pacific/Kiritimati",
                    label: "(GMT+14:00) Kiritimati"
                }
            ]
        }
    ];
}